define.alias("shared/components/shared/user/info", "settings/components/shared/user/info");